if (!customElements.get('dtf-gang-upload')) {
  customElements.define('dtf-gang-upload', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.root = this.closest('product-info');
      this.template = this.querySelector('template');
      if (!this.root || !this.template) return;

      this.events = new AbortController();
      this.root.addEventListener('keydown', (event) => {
        if (!event.target.matches('#gs-file-drop-zone.dtf-gang-upload--ready')) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (!event.repeat) event.target.click();
      }, { signal: this.events.signal });

      // The app can arrive late or remount after a variant/editor update.
      this.observer = new MutationObserver(() => this.enhance());
      this.observer.observe(this.root, { childList: true, subtree: true });
      this.enhance();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.events?.abort();
    }

    enhance() {
      this.root.querySelectorAll('#gs-uploader-btn[data-type="gang-upload"] #gs-file-drop-zone').forEach((zone) => {
        if (zone.querySelector('.dtf-gang-upload__content')) return;

        const content = this.template.content.firstElementChild.cloneNode(true);
        const types = zone.querySelector('.gs-file-types')?.textContent.trim();
        const limit = [...zone.children].find((node) => /max file size/i.test(node.textContent))?.textContent.trim();
        content.querySelector('[data-gang-file-meta]').textContent = [
          types?.replace(/^files supported:\s*/i, '').toUpperCase(),
          limit,
        ].filter(Boolean).join(' · ');

        // Keep the app's nodes intact, including any attached event listeners.
        zone.appendChild(content);
        zone.classList.add('dtf-gang-upload--ready');
        zone.setAttribute('role', 'button');
        zone.setAttribute('tabindex', '0');
        zone.setAttribute('aria-label', 'Browse files to upload your gang sheet');
        zone.closest('.gs--wrapper')?.classList.add('dtf-gang-upload__wrapper');
        zone.closest('.gs-uploader-wrapper')?.classList.add('dtf-gang-upload__wrapper');
      });
    }
  });
}
